export const EMPTY_TERM_ROW = () => Array(5).fill("");

export function normalizeTermWord(value = "") {
  return value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z]/g, "")
    .toUpperCase()
    .trim();
}

export function maxTermAttempts(mode) {
  return Number(mode) === 1 ? 6 : Number(mode) === 2 ? 7 : 9;
}

export function evaluateTermGuess(secret, guess) {
  const normalizedSecret = normalizeTermWord(secret);
  const normalizedGuess = normalizeTermWord(guess);
  const result = Array(5).fill(null);
  const remaining = normalizedSecret.split("");

  for (let index = 0; index < 5; index += 1) {
    if (normalizedGuess[index] === normalizedSecret[index]) {
      result[index] = { letra: normalizedGuess[index], cor: "verde" };
      remaining[index] = null;
    }
  }
  for (let index = 0; index < 5; index += 1) {
    if (result[index]) continue;
    const position = remaining.indexOf(normalizedGuess[index]);
    if (position === -1) {
      result[index] = { letra: normalizedGuess[index], cor: "cinza" };
    } else {
      result[index] = { letra: normalizedGuess[index], cor: "amarelo" };
      remaining[position] = null;
    }
  }
  return result;
}

export function evaluateTermGuesses(secret, guesses) {
  return guesses.map((guess) => evaluateTermGuess(secret, guess));
}

export function solvedTermCount(secrets, guesses) {
  const normalizedGuesses = new Set(guesses.map(normalizeTermWord));
  return secrets.filter((secret) =>
    normalizedGuesses.has(normalizeTermWord(secret)),
  ).length;
}

export function termKeyboardState(secrets, guesses) {
  const state = {};
  for (const secret of secrets) {
    const normalizedSecret = normalizeTermWord(secret);
    for (const guess of guesses) {
      const normalizedGuess = normalizeTermWord(guess);
      for (let index = 0; index < normalizedGuess.length; index += 1) {
        const letter = normalizedGuess[index];
        if (normalizedSecret[index] === letter) state[letter] = "verde";
        else if (
          normalizedSecret.includes(letter) &&
          state[letter] !== "verde"
        ) {
          state[letter] = "amarelo";
        } else if (!normalizedSecret.includes(letter) && !state[letter]) {
          state[letter] = "cinza";
        }
      }
    }
  }
  return state;
}

export function calculateTermBoardLayout(width, mode) {
  const numericMode = Number(mode);
  const columns =
    numericMode === 1 ? 1 : numericMode === 2 ? 2 : width >= 620 ? 4 : 2;
  const cell = (width - (columns - 1) * 16 - columns * 16) / (columns * 5);
  return { columns, cell: Math.max(22, Math.min(64, Math.floor(cell))) };
}

export function drawTermWords(words, amount, random = Math.random) {
  return [...words].sort(() => 0.5 - random()).slice(0, amount);
}
